<script setup lang="ts">
import type { NuxtError } from '#app'

interface Props {
  error: NuxtError<string>
}

const props = defineProps<Props>()

useHead({
  title: props.error.statusCode.toString(),
})
</script>

<template>
  <div>
    <MainLayout>
      <ErrorMessage
        :title="`${error.statusCode}`"
        :description="error.message"
        back-link-label="Return to Home"
        back-link-url="/"
      />
    </MainLayout>
  </div>
</template>
